@if (previewUrl) {
  <img class="preview" [class.hide]="isPlaying" [src]="previewUrl | safeUrl" />
}
<video #video [src]="src" [class.no-display]="isPlaying && isIframe" [controls]="showControls" [autoplay]="startTime" (pause)="onPause()"
(play)="onPlay()" (click)="pauseVideo($event)"></video>
<icon-button icon="play_video" [class.hide]="isPlaying" (click)="playVideo()"></icon-button>